
// 系统管理-->人员和权限-->中英文
export const permission = {
    'zhCN': {
        userlist: {
            searchname: '姓名',
            employeeStatus: '员工状态',
            userType: '用户类型',
            gender: '性别',
            position: '职务',
            status: '状态',
            viewUerInformation: '查看用户信息',
            department: '部门',
            addUser: '新增CDMS用户',
            cdmsUser: 'CDMS用户',
            email: '邮箱',
            telephone: '电话',
            lineManagerMUID: '直线上级',
            entryDate: '入职日期',
            lastWorkDay: '离职日期',
            synchronizationDate: '同步时间',
            roleDesc: '所属角色'
        }
    },
    'enUS': {
        userlist: {
            searchname: 'Name',
            employeeStatus: 'Employee Status',
            userType: 'User Type',
            gender: 'Gender',
            position: 'Position',
            status: 'Status',
            viewUerInformation: 'View user information',
            department: 'Department',
            addUser: 'Add User',
            cdmsUser: 'CDMS User',
            email: 'Email',
            telephone: 'Telephone',
            lineManagerMUID: 'Line Manager',
            entryDate: 'HireDate',
            lastWorkDay: 'LeaveDate',
            synchronizationDate: 'SynchronizationDate',
            roleDesc: 'User role'
        }
    }
}
export default permission



// WEBPACK FOOTER //
// ./src/locale/modules/permission.js